import styled from 'styled-components'

import { ButtonIcon } from '../ButtonIcon'

export const Button = styled(ButtonIcon)`
	height: 100%;
	margin: 0;
	width: 40px;

	&:last-child {
		border-radius: 0 2px 2px 0;
	}
`
